"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var core_1 = require("@material-ui/core");
var react_redux_1 = require("react-redux");
var Masthead_1 = __importDefault(require("./Masthead"));
var BaseLayoutHeader_1 = __importDefault(require("./BaseLayoutHeader"));
// import BaseLayoutLowFooter from './BaseLayoutLowFooter'
// import BaseLayoutFooter from './BaseLayoutFooter'
var ie_1 = __importDefault(require("./util/ie"));
var BannerForIE_1 = __importDefault(require("./BannerForIE"));
var types_1 = require("../../util/types");
var Banner_1 = __importDefault(require("./widgets/Banner"));
var asset_variant_1 = __importDefault(require("../../../../shared/util/asset-variant"));
var Footer_1 = __importDefault(require("./Footer"));
var displayMasthead = asset_variant_1.default === 'gov';
var useStyles = core_1.makeStyles(function () {
    return core_1.createStyles({
        '@global': {
            body: {
                display: 'flex',
                backgroundColor: 'transparent',
                '& #root': {
                    flexGrow: 1,
                    '-ms-flex': '1 1 auto',
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: '100vh',
                    overflow: 'hidden',
                },
            },
            a: {
                textDecoration: 'none',
            },
        },
        layout: {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            '-ms-flex': '1 1 auto',
            backgroundColor: '#F4F7FA',
        },
    });
});
var BaseLayout = function (_a) {
    var _b = _a.withHeader, withHeader = _b === void 0 ? true : _b, _c = _a.headerBackgroundType, headerBackgroundType = _c === void 0 ? 'light' : _c, _d = _a.withFooter, withFooter = _d === void 0 ? true : _d, 
    // withLowFooter = true,
    children = _a.children, layoutStyle = _a.layoutStyle;
    var classes = useStyles();
    var path = react_router_dom_1.useLocation().pathname;
    var isIE = ie_1.default();
    var message = react_redux_1.useSelector(function (state) { return state.user.message; });
    var theme = core_1.useTheme();
    var isMobileVariant = core_1.useMediaQuery(theme.breakpoints.down('xs'));
    var toStick = isIE || !!message;
    // To store y-position to trigger useEffect
    var prevScrollY = react_1.useRef(0);
    var _e = __read(react_1.useState(false), 2), isSticky = _e[0], setIsSticky = _e[1];
    react_1.useEffect(function () {
        var handleScroll = function () {
            var currentScrollY = window.pageYOffset;
            // height of mast
            if (currentScrollY >= 28) {
                setIsSticky(true);
            }
            else {
                setIsSticky(false);
            }
            prevScrollY.current = currentScrollY;
        };
        window.addEventListener('scroll', handleScroll);
        return function () { return window.removeEventListener('scroll', handleScroll); };
    }, [prevScrollY]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.CssBaseline, null),
        displayMasthead && react_1.default.createElement(Masthead_1.default, { isSticky: isSticky, toStick: toStick }),
        path === types_1.USER_PAGE && isIE && react_1.default.createElement(BannerForIE_1.default, { isSticky: isSticky }),
        path === types_1.USER_PAGE && message && (react_1.default.createElement(Banner_1.default, { text: message, isSticky: isSticky })),
        withHeader && (react_1.default.createElement(BaseLayoutHeader_1.default, { backgroundType: headerBackgroundType, hideNavButtons: isMobileVariant, isSticky: isSticky, toStick: toStick })),
        react_1.default.createElement("div", { className: classes.layout, style: layoutStyle }, children),
        withFooter && react_1.default.createElement(Footer_1.default, null)));
};
exports.default = BaseLayout;
